module.exports = __webpack_public_path__ + "static/bonus-chapter.ecf04ef5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/graphics/bonus-chapter.png
// module id = ./src/assets/graphics/bonus-chapter.png
// module chunks = 0